var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-b-5", attrs: { "data-testid": "invites" } },
    [
      !_vm.loading
        ? _c(
            "div",
            { staticClass: "m-t-10 m-b-15" },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-success btn-sm",
                  attrs: { type: "button", disabled: _vm.showAddNewForm },
                  on: { click: _vm.showForm }
                },
                [
                  _c("i", { staticClass: "fa fa-plus" }),
                  _vm._v(" "),
                  _c("span", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "INVITE_USER",
                        expression: "'INVITE_USER'"
                      }
                    ]
                  })
                ]
              ),
              _vm._v(" "),
              _vm.invites.length
                ? _c("v-select", {
                    staticClass:
                      "btn-xl pull-right table-filter-dropdown m-t-0",
                    attrs: {
                      clearable: false,
                      searchable: false,
                      options: [
                        "All",
                        "Accepted",
                        "Pending",
                        "Expired",
                        "Declined"
                      ]
                    },
                    on: { input: _vm.filterChange },
                    model: {
                      value: _vm.inviteFilter,
                      callback: function($$v) {
                        _vm.inviteFilter = $$v
                      },
                      expression: "inviteFilter"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "div",
            { staticClass: "invites-container" },
            [
              !_vm.showAddNewForm && _vm.emptyInvites
                ? _c("div", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "NO_INVITED_USERS",
                        expression: "'NO_INVITED_USERS'"
                      }
                    ],
                    staticClass: "well well-sm"
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showAddNewForm
                ? _c("InviteForm", {
                    attrs: {
                      "existing-users": _vm.existingUsersExcludingAccepted
                    },
                    on: {
                      submit: _vm.submitNewInvite,
                      cancel: function($event) {
                        _vm.showAddNewForm = false
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.invites && _vm.invites.length && !_vm.filteredInvites.length
                ? _c("div", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: _vm.emptyListMessage,
                        expression: "emptyListMessage"
                      }
                    ],
                    staticClass: "invites-sent well well-sm"
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.filteredInvites, function(invite) {
                return _c(
                  "div",
                  { key: invite.id, staticClass: "invites-sent well well-sm" },
                  [
                    _c("div", { staticClass: "invite-user-details" }, [
                      _c("h2", { staticClass: "invite-user-name" }, [
                        _vm._v(
                          "\n          " + _vm._s(invite.name) + "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-t-5 invite-user-email" }, [
                        _vm._v(
                          "\n          " + _vm._s(invite.email) + "\n        "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "label f-s-11",
                      class: invite.statusClass,
                      domProps: { textContent: _vm._s(invite.status) }
                    }),
                    _vm._v(" "),
                    _c("div", [
                      _vm.copyUrlSupported
                        ? _c(
                            "a",
                            {
                              staticClass: "btn btn-function",
                              style: {
                                visibility: invite.url ? "visible" : "hidden"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.copyInviteURLToClipboard(
                                    invite.url
                                  )
                                }
                              }
                            },
                            [
                              _c("i", {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip.left",
                                    value: _vm.$t("COPY_INVITE_URL"),
                                    expression: "$t('COPY_INVITE_URL')",
                                    modifiers: { left: true }
                                  }
                                ],
                                staticClass: "typcn typcn-code"
                              })
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-function",
                          on: {
                            click: function($event) {
                              return _vm.confirmDeleteModal(invite)
                            }
                          }
                        },
                        [
                          !invite.user
                            ? _c("i", {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip.left",
                                    value: _vm.$t("DELETE_INVITE"),
                                    expression: "$t('DELETE_INVITE')",
                                    modifiers: { left: true }
                                  }
                                ],
                                staticClass: "typcn typcn-trash"
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          invite.user
                            ? _c("i", {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip.left",
                                    value: _vm.$t("DELETE_USER"),
                                    expression: "$t('DELETE_USER')",
                                    modifiers: { left: true }
                                  }
                                ],
                                staticClass: "typcn typcn-trash"
                              })
                            : _vm._e()
                        ]
                      )
                    ])
                  ]
                )
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "well well-sm text-center" },
            [
              _c("Loader"),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "LOADING_INVITES",
                    expression: "'LOADING_INVITES'"
                  }
                ]
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: { title: _vm.deleteModalTitle },
          on: { hide: _vm.hideModal },
          model: {
            value: _vm.showModal,
            callback: function($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal"
          }
        },
        [
          _c("p", { domProps: { innerHTML: _vm._s(_vm.deleteModalText) } }),
          _vm._v(" "),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c("button", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "DELETE",
                  expression: "'DELETE'"
                }
              ],
              staticClass: "btn btn-primary",
              attrs: { type: "button" },
              on: { click: _vm.deleteInviteOrUser }
            }),
            _vm._v(" "),
            _c("button", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "CANCEL",
                  expression: "'CANCEL'"
                }
              ],
              staticClass: "btn btn-danger",
              attrs: { type: "button" },
              on: { click: _vm.hideModal }
            })
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }